export default "__VITE_ASSET__CAurfstD__"